export const SAVE_BOARD_SETTINGS = 'events/SAVE_BOARD_SETTINGS';

/**
 * @param board
 * @return {{type: string, payload: board}
 */
export const saveBoardSettings = (board) => ({
  type: SAVE_BOARD_SETTINGS,
  payload: board,
});
